module.exports = __webpack_public_path__ + "static/media/run_5.714f49a5.png";